__turbopack_context__.v({
  "badges": "positionTable-module-scss-module__lhkjAW__badges",
  "buttons": "positionTable-module-scss-module__lhkjAW__buttons",
  "closePosition": "positionTable-module-scss-module__lhkjAW__closePosition",
  "flip": "positionTable-module-scss-module__lhkjAW__flip",
  "link": "positionTable-module-scss-module__lhkjAW__link",
  "multiLine": "positionTable-module-scss-module__lhkjAW__multiLine",
  "noData": "positionTable-module-scss-module__lhkjAW__noData",
  "share": "positionTable-module-scss-module__lhkjAW__share",
  "size": "positionTable-module-scss-module__lhkjAW__size",
  "symbol": "positionTable-module-scss-module__lhkjAW__symbol",
  "table": "positionTable-module-scss-module__lhkjAW__table",
  "wrapper": "positionTable-module-scss-module__lhkjAW__wrapper",
});
